import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';

import {labels} from '../../../../util/utils';

import {getActivityLog} from '../../../../actions/ActivityLog';
import selectActivityLogData from '../../../../reducers/ActivityLog/selectors/selectActivityLogData';
import selectAllEntitiesIds from '../../../../reducers/Metrics/selector/selectAllEntitiesIds';
import selectProjectId from '../../../../reducers/Project/selectors/selectProjectId';

import ActivityTable from '../../../Common/ActivityTable';
import StyledActivityFeed from './StyledActivityFeed';
import GenerateExcel from './GenerateExcel/index';

const ActivityFeed = () => {
	const [isLoading, setIsLoading] = useState(false);

	const dispatch = useDispatch();
	const [items, _] = selectActivityLogData();
	const entities = selectAllEntitiesIds();
	const projectId = selectProjectId();

	useEffect(() => {
		if (projectId) handleGetActivityLog();
	}, [projectId, entities.length]);

	const handleGetActivityLog = (tableConfig = null) => {
		setIsLoading(true);
		const args = [projectId, entities];
		if (tableConfig) {
			const {column: orderBy, direction, page, pageSize} = tableConfig;
			args.push({page, pageSize, orderBy, orderByAscending: direction === 'asc'});
		} else {
			args.push({page: 1, pageSize: 20, orderBy: 'activityDate', orderByAscending: false});
		}
		dispatch(getActivityLog(...args)).then(() => setIsLoading(false));
	};

	const props = {
		items,
		labels: {
			noDataToDisplay: labels.noGroupRiskAssessmentForSelection,
			show: labels.show
		},
		handleGetActivityLog
	};

	return (
		<StyledActivityFeed isLoading={isLoading} blockContent>
			<GenerateExcel />
			<ActivityTable {...props} />
		</StyledActivityFeed>
	);
};

ActivityFeed.propTypes = {};

export default ActivityFeed;
